import { Router } from "@angular/router";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment.prod";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class StaticPagesService {
    envConfigration = new BehaviorSubject(null);
    constructor(private http: HttpClient, private router: Router) {}

    /// ======= contact Us  ======= ///
    contactUs(data: any) {
        return this.http.post<any>(
            `${environment.api}/api/customer/contact_us`,
            data
        );
    }
    getBranches(): Observable<any> {
        return this.http.get<any>(
            environment.api + "/api/customer/orders/branches"
        );
    }
    getPargoBranches(name=''): Observable<any> {
        return this.http.get<any>(
            environment.api + "/api/customer/orders/pargo_pickup_points",{params : {
                address:name
            }}
        );
    }
    getPdfUrl(slug: string): Observable<any> {
        return this.http.get<any>(
            environment.api + "/api/customer/pdf/" + slug
        );
    }
    getStaticPage(slug: any, flag: any): Observable<any> {
        return this.http.get<any>(
            `${environment.api}/api/customer/pages/${slug}`,
            { params: { flag } }
        );
    }
    getAllStaticPages(): Observable<any> {
        return this.http.get<any>(`${environment.api}/api/customer/pages`);
    }
    getConfigrationVariables(): Observable<any> {
        return this.http.get<any>(
            `${environment.api}/api/customer/configurations`
        );
    }
    setenvConfig(envValue: any) {
        let socialSignIn = {
            googleSignInId: envValue?.GOOGLE_CLIENT_ID || "",
            facebookSignInId: envValue?.FACEBOOK_CLIENT_ID || "",
        };
        this.storeIds(socialSignIn);
        localStorage.setItem("environmentVariables", JSON.stringify(envValue));
        this.envConfigration.next(envValue);
    }

    setenvConfigOfflineApp(envValue: any) {
        let socialSignIn = {
            googleSignInId: envValue?.GOOGLE_CLIENT_ID || "",
            facebookSignInId: envValue?.FACEBOOK_CLIENT_ID || "",
        };
        this.storeIds(socialSignIn);
        localStorage.setItem("environmentVariables", JSON.stringify(envValue));
        this.envConfigration.next(envValue);
    }

    getenvConfig(): Observable<any> {
        return this.envConfigration.asObservable();
    }

    storeIds(socialIds: any) {
        sessionStorage.setItem("socialIds", JSON.stringify(socialIds));
    }
}
